import { DashboardVerificationCount } from "@idw-types/data/dashboard";
import { CardContainer } from "../../common/card-container/card-container";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";
import { DashboardVerificationCountsSplineChart } from "./dashboard-verification-counts-spline-chart/dashboard-verification-counts-spline-chart";
import { TimeRangeTypes } from "@enums/time-range-types";
import styles from "./dashboard-verification-counts-container.less";

type DashboardVerificationCountsContainerProps = {
    dashboardVerificationCounts: Array<DashboardVerificationCount>;
    timeRangeType: TimeRangeTypes;
    startDate: Date;
    endDate: Date;
};

export const DashboardVerificationCountsContainer = (props: DashboardVerificationCountsContainerProps) => {
    const { dashboardVerificationCounts, timeRangeType, startDate, endDate } = props;

    return (
        <CardContainer>
            <ContentPageBody isMaxWidth={true}>
                <div className={styles.graphContainer}>
                    <div className={styles.dashboardVerificationCountsSplineChartContainer}>
                        <DashboardVerificationCountsSplineChart
                            verificationCounts={dashboardVerificationCounts}
                            timeRangeType={timeRangeType}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </div>
                </div>
            </ContentPageBody>
        </CardContainer>
    );
};